/** The FileDropPickerEvent will be dispatched when the user selects a file with the FileDropPicker component. */
export default class FileDropPickerEvent extends Event {
	public static FILE_SELECTED = 'FileDropPickerEvent.fileSelected';

	/** Returns the selected file. */
	public get file(): File {
		return this.#file;
	}

	#file: File;

	public constructor(file: File) {
		super(FileDropPickerEvent.FILE_SELECTED, { bubbles: true });
		this.#file = file;
	}
}
